import React, { useState, useRef, useEffect } from 'react';
import CustomImage from '../../../components/custom-image';
import SectionTitle from '../../../components/section-title';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';
import useOutsideClick from '../../../utils/useOutsideClick';

const FirmFoundationLastingValue = () => {
  const wrapperRef = useRef(null);
  const [showImage, setShowImage] = useState(false);

  useOutsideClick(wrapperRef, () => {
    setShowImage(false);
  });

  return (
    <div>
      <div className="firm-foundation-lasting-value">
        <div className="container-1440">
          <div className="container">
            <div className="container-inner">
              <ScrollPositionAnimation targetElement1="anim-3" targetElement2="anim-4">
                <div className="content-row">
                  <div className="column-40">
                    <div className="left-content">
                      <div className="left-to-right anim-3">
                        <CustomImage
                          className="custom-image"
                          imageName="firm-foundation-lasting-value.png"
                          alt="Firm Foundation Lasting Value"
                          maxWidth="586"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="column-55">
                    <div className="right-content">
                      <div className="bottom-to-top anim-4">
                        <SectionTitle
                          lighttext="FIRM FOUNDATION FOR"
                          boldtext="LASTING VALUE"
                          iconimage="icon-firm-foundation.png"
                          alt="Sustainability esg"
                          isSectionH1={false}
                        />
                        <div className="description">
                          <p>
                            Good corporate governance, which is a pre-requisite for protecting shareholder value, as
                            well as delivering sustainable growth, underpins the delivery of our strategic objectives.
                            By overseeing the conduct of business with strict adherence to ethics and responsibility,
                            the entire structure, cascading from the Board of Directors at the top, supported by
                            processes, policies and the Vedanta Sustainability Framework, enhances the prosperity,
                            long-term viability and sustainability of the Company.
                          </p>
                        </div>
                        <div className="sub-title">
                          <h3>Composition of the Board</h3>
                          <p>
                            In pursuance of our commitment towards responsible business in compliance with the
                            applicable provisions of Companies Act, 2013 and Securities and Exchange Board of India
                            (SEBI) Listing Regulations, including the amendments thereof, our Board presents an
                            appropriate balance between Executive, Non-Executive and Independent Directors to distinct
                            its functions of management and governance, to promote shareholder interests and to govern
                            Vedanta effectively.
                          </p>
                        </div>
                        <div className="blue-box">
                          <p>
                            Our governance philosophy stems from our values of Trust, Entrepreneurship, Innovation,
                            Excellence, Integrity, Respect and Care.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollPositionAnimation>
              <div className="board-comprieses">
                <ScrollPositionAnimation targetElement2="anim-5">
                  <div className="bottom-to-top anim-5">
                    <p>As on 2 June 2020, the Board comprises eight members as listed below:</p>
                    <div className="board-comprieses-table">
                      <div className="desktop-img">
                        <CustomImage
                          className="custom-image"
                          imageName="board-comprieses-table.png"
                          alt="Composition of the Board"
                          maxWidth="1200"
                        />
                      </div>
                      <div className="mobile-img">
                        <button
                          ref={wrapperRef}
                          className="table-popup"
                          onClick={(e) => {
                            setShowImage(!showImage);
                          }}
                        >
                          <CustomImage
                            className="custom-image"
                            imageName="icon-info.svg"
                            alt="Composition of the Board"
                            maxWidth="19"
                          />
                        </button>
                        {showImage && (
                          <div className="show-img">
                            <CustomImage
                              className="custom-image"
                              imageName="board-comprieses-age-popup.png"
                              alt="Composition of the Board"
                              maxWidth="278"
                            />
                          </div>
                        )}
                        <CustomImage
                          className="table-image"
                          imageName="board-comprieses-table-mobile.png"
                          alt="Composition of the Board"
                          maxWidth="337"
                        />
                      </div>
                    </div>
                  </div>
                </ScrollPositionAnimation>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirmFoundationLastingValue;
